exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.language_combo.v-text-field > .v-input__control > .v-input__slot:before {\n  border: 0px;\n}\n.vuetify-combo .v-input__slot {\n  border: solid 1px #ced4da;\n  margin-bottom: 0 !important;\n}\n.vuetify-combo.v-text-field.v-text-field--enclosed .v-text-field__details {\n  display: none;\n}\n", ""]);

// exports
